export default __webpack_public_path__ + "media/images/ico-free-delivery-2e4f1bf102a007a2be53f59e13df8578.svg";